<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">Connect Agency</h4>

          <div class="flex md:ml-auto mt-4 md:mt-0">
            <BaseButton
              tag="router-link"
              :to="{ name: 'accounts.accountId.agencies', params: { accountId } }"
              primary
              class="ml-auto md:ml-4"
            >
              Back
            </BaseButton>
          </div>
        </div>
      </div>
    </div>

    <div class="px-4 pb-4 lg:px-12 lg:pb-12 -mt-12">
      <div class="max-w-5xl mx-auto">
        <div class="space-y-16">
          <VList>
            <template #before>
              <div class="hidden lg:flex font-medium text-sm text-gray-600 mb-4 pr-2">
                <div class="flex-1 px-4">Name</div>
              </div>
            </template>

            <template v-if="agencies.length" #default>
              <template v-for="agency in agencies">
                <div
                  :key="`agencies_${agency.id}`"
                  class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 text-sm"
                >
                  <div class="flex -mx-4 justify-between items-center">
                    <div class="flex-1 p-4">
                      <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
                        <div class="flex-1 px-4">
                          <h5 class="text-sm">
                            {{ agency.name }}
                          </h5>
                        </div>

                        <div class="w-32 px-4 mt-4 lg:mt-0 text-right">
                          <BaseButton primary :disabled="loading" @click="connectAgency(agency)">
                            Connect
                          </BaseButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>

            <template v-else #default>
              <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
                No results found. Looks like you have already connected to all available agencies.
              </div>
            </template>
          </VList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import { getOrganizationListApi, clientAgenciesClient } from '@/api/clients';
import VList from '@/components/Common/VList.vue';

export default {
  components: {
    VList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      agencies: [],
      loading: false,
    };
  },

  beforeRouteEnter(to, from, next) {
    const check = middleware('account-permission:create agencies');

    check(to, from, async (args) => {
      if (typeof args !== 'undefined') {
        return next(...args);
      }

      try {
        const { data: { data: agencies = [] } = {} } = await getOrganizationListApi({
          filter: {
            missing_clients: to.params.accountId,
          },
        });

        return next((vm) => {
          vm.setData({ agencies });
        });
      } catch (error) {
        return next(false);
      }
    });
  },

  methods: {
    setData(data) {
      this.agencies = data.agencies;
    },

    async connectAgency(agency) {
      try {
        this.loading = true;

        await clientAgenciesClient.store(this.accountId, {
          agencyUuid: agency.id,
        });

        this.$router.push({
          name: 'accounts.accountId.agencies',
          params: { accountId: this.accountId },
        });
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
